import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  productTypeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  textHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.labraCheckbox.main,
  },
  sectionHeading: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  sectionText: {
    fontSize: '14px !important',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px !important',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  field: {
    width: '485px',
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    alignSelf: 'stretch',
  },
  checkboxWidth: {
    width: theme.spacing(30.5),
  },
  productTypeChangeText: {
    color: theme.palette.labraText.description,
    fontWeight: 400,
    fontSize: theme.spacing(1.75),
    lineHeight: '20px',
  },
  productTypeChangeTextNote: {
    fontWeight: 600,
  },
  productTypeChangeConfirmText: {
    marginBottom: theme.spacing(1.5),
  },
  fullWidth: {
    width: '100%',
  },
  containerMargin: {
    marginBottom: '-16px',
  },
  errorMessage: {
    color: theme.palette.error.dark,
    fontSize: '12px',
    marginTop: theme.spacing(1),
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
  checkboxContainerTooltip: {
    width: '100%',
  },
}))
